import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

const ProjectLightbox = ({ open, onOpenChange, projects, index, setIndex, clientName }) => {
  if (!projects || projects.length === 0) return null;
  const project = projects[index] || projects[0];

  const prev = (e) => { e?.stopPropagation?.(); setIndex((index - 1 + projects.length) % projects.length); };
  const next = (e) => { e?.stopPropagation?.(); setIndex((index + 1) % projects.length); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-[95vw] md:max-w-[85vw] lg:max-w-[1100px] p-0 bg-[#0A0A0A] border-stone-800 overflow-hidden"
      >
        <DialogTitle className="sr-only">{project.title}</DialogTitle>
        <DialogDescription className="sr-only">
          {clientName} — {project.type}
        </DialogDescription>
        <div className="relative flex flex-col">
          <div className="flex items-center justify-between px-5 py-4 border-b border-stone-800">
            <div>
              <p className="font-mono-label text-stone-300">{clientName} · {project.type}</p>
              <h4 className="font-display text-xl text-stone-100 mt-1">{project.title}</h4>
            </div>
            <button
              onClick={() => onOpenChange(false)}
              className="w-10 h-10 rounded-full border border-stone-800 hover:bg-[#242424] flex items-center justify-center"
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </div>

          <div className="relative bg-[#1A1A1A] flex items-center justify-center min-h-[50vh]">
            <img
              src={project.image}
              alt={project.title}
              className="max-h-[75vh] w-auto object-contain"
            />
            {projects.length > 1 && (
              <>
                <button
                  onClick={prev}
                  className="absolute left-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-[#0A0A0A] border border-stone-800 hover:bg-[#0F0F0F] flex items-center justify-center shadow-sm"
                  aria-label="Previous"
                >
                  <ChevronLeft size={18} />
                </button>
                <button
                  onClick={next}
                  className="absolute right-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-[#0A0A0A] border border-stone-800 hover:bg-[#0F0F0F] flex items-center justify-center shadow-sm"
                  aria-label="Next"
                >
                  <ChevronRight size={18} />
                </button>
              </>
            )}
          </div>

          <div className="px-5 py-3 flex items-center justify-between border-t border-stone-800">
            <span className="font-mono-label text-stone-300">
              {String(index + 1).padStart(2, "0")} / {String(projects.length).padStart(2, "0")}
            </span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProjectLightbox;
